import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Customer } from "@/types/customer";
import { User, ShieldBan } from "lucide-react";

interface CustomerInfoDialogProps {
  customer: Customer | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function CustomerInfoDialog({ customer, open, onOpenChange }: CustomerInfoDialogProps) {
  if (!customer) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm" dir="rtl">
        <DialogHeader className="text-right pb-4 border-b">
          <DialogTitle className="flex items-center gap-3">
            <div className="h-12 w-12 rounded-full bg-primary/10 flex items-center justify-center">
              <User className="h-6 w-6 text-primary" />
            </div>
            <div className="flex flex-col items-start gap-1">
              <span className="text-lg">{customer.fullName}</span>
              <div className="flex items-center gap-2">
                <Badge variant="outline" className="text-xs">#{customer.customerCode}</Badge>
                {customer.isBlocked && (
                  <Badge variant="destructive" className="text-xs">
                    <ShieldBan className="h-3 w-3 ml-1" />
                    بلۆک کراو
                  </Badge>
                )}
              </div>
            </div>
          </DialogTitle>
        </DialogHeader>
        
        <div className="space-y-3 pt-2">
          {/* ژمارە مۆبایل ١ */}
          <div className="flex justify-between items-center py-2 border-b border-dashed">
            <span className="text-muted-foreground text-sm">مۆبایل ١</span>
            <span className="font-medium" dir="ltr">{customer.phone1}</span>
          </div>

          {/* ژمارە مۆبایل ٢ */}
          {customer.phone2 && (
            <div className="flex justify-between items-center py-2 border-b border-dashed">
              <span className="text-muted-foreground text-sm">مۆبایل ٢</span>
              <span className="font-medium" dir="ltr">{customer.phone2}</span>
            </div>
          )}

          {/* پیشە */}
          {customer.job && (
            <div className="flex justify-between items-center py-2 border-b border-dashed">
              <span className="text-muted-foreground text-sm">پیشە</span>
              <span className="font-medium">{customer.job}</span>
            </div>
          )}

          {/* ناونیشان */}
          {customer.address && (
            <div className="flex justify-between items-center py-2 border-b border-dashed">
              <span className="text-muted-foreground text-sm">ناونیشان</span>
              <span className="font-medium">{customer.address}</span>
            </div>
          )}

          {/* کەفیل */}
          {customer.guarantorName && (
            <div className="flex justify-between items-center py-2 border-b border-dashed">
              <span className="text-muted-foreground text-sm">کەفیل</span>
              <span className="font-medium">{customer.guarantorName}</span>
            </div>
          )}

          {/* ژمارەی کەفیل */}
          {customer.guarantorPhone && (
            <div className="flex justify-between items-center py-2 border-b border-dashed">
              <span className="text-muted-foreground text-sm">ژمارەی کەفیل</span>
              <span className="font-medium" dir="ltr">{customer.guarantorPhone}</span>
            </div>
          )}

          {/* تێبینی */}
          {customer.notes && (
            <div className="flex justify-between items-center py-2 border-b border-dashed">
              <span className="text-muted-foreground text-sm">تێبینی</span>
              <span className="font-medium text-left max-w-[200px]">{customer.notes}</span>
            </div>
          )}

          {/* دۆخ */}
          <div className="flex justify-between items-center py-2">
            <span className="text-muted-foreground text-sm">دۆخ</span>
            {customer.isBlocked ? (
              <Badge variant="destructive" className="text-xs">بلۆک کراو</Badge>
            ) : (
              <Badge variant="default" className="text-xs bg-green-600">چالاک</Badge>
            )}
          </div>
        </div>

        {/* دوگمەی داخستن */}
        <div className="pt-4 border-t">
          <Button 
            variant="outline" 
            className="w-full"
            onClick={() => onOpenChange(false)}
          >
            داخستن
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
